import axiosInstance from 'services/axiosMiddleware';

// Updated function to accept category data
export async function AssignStudentCourse(coursedata) {
  try {
    const response = await axiosInstance.post('course/assignCourse', coursedata);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
